import { I18nValue, LangCode, getFullLocalizedUri } from '../i18n/lang-context'

export type Author = {
  teamOrder: number
  slug: string
  name: string
  title: I18nValue
  email: string
  phone: string
  linkedInUserId: string
  linkedInShowcaseId: string
  linkedInCompanyId: string
  twitterId: string
  instagramId: string
  facebookId: string
  youtubeId: string
  bio: I18nValue
  photo: {
    url: string
  }
  post: any[]
}

export function toAuthor(_author: any,  langCode: LangCode) {
  const author = {..._author}
  const title = author.title
  author.title = {}
  author.title[langCode] = title
  const bio = author.bio
  author.bio = {}
  author.bio[langCode] = bio
  return author
}
export function toAuthors(_authors: any[],  langCode: LangCode) {
  const results: Author[] =[]
  for(let _author of _authors) {
    results.push(toAuthor(_author, langCode))
  }
  return results
}

export function buildAuthorUrl(author: Author, langCode: LangCode) {
  return getFullLocalizedUri('/about-us?member=' + author.slug, langCode)
}